import React from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState } from "react";
import Loading from "../components/loading/Loading";

function PrivacyPolicy() {
    const [isLoading, setLoading] = useState(false);
    return (
        <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"Privacy Policy"} />
        <Menu
            parentmenu={"policy"}
            activemenu={"infoPrivacyPolicy"}
        />
        <div className="content-wrapper">
            <div className="container-fluid  pdb-page">
                <h1>Privacy Policy</h1>
            </div>
        </div>
        <Footer/>
        </>
    )
}

export default PrivacyPolicy